import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../entries/common/request";
import { BaseApi } from "../core/base-api";
import { makeMethod } from "../core/base-api/methods-maker";
export var TagsApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(TagsApi, _BaseApi);

  var _super = _createSuper(TagsApi);

  function TagsApi() {
    _classCallCheck(this, TagsApi);

    return _super.apply(this, arguments);
  }

  return TagsApi;
}(BaseApi);
/**
 * list available genres. paged
 */

TagsApi.prototype.listGenres = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.ListGenres
});
/**
 * list available topics. paged
 */

TagsApi.prototype.listTopics = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.ListTopics
});
/**
 * list available countries. paged
 */

TagsApi.prototype.listCountries = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.ListCountries
});
/**
 * show tag info
 */

TagsApi.prototype.showGenre = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.ShowGenre
});
/**
 * show tag info
 */

TagsApi.prototype.showTopic = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.ShowTopic
});
/**
 * tag info
 */

TagsApi.prototype.showCountry = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.ShowCountry
});
/**
 * list available videos for tag. paged
 */

TagsApi.prototype.listGenreVideos = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.ListGenreVideos
});
/**
 * list available videos for tag. paged
 */

TagsApi.prototype.listTopicVideos = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.ListTopicVideos
});
/**
 * list available videos for tag. paged
 */

TagsApi.prototype.listCountryVideos = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.ListCountryVideos
});
/**
 * index of video in collection
 */

TagsApi.prototype.findCountryVideoIndex = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.FindCountryVideoIndex
});
/**
 * index of video in collection
 */

TagsApi.prototype.findTopicVideoIndex = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.FindTopicVideoIndex
});
/**
 * index of video in collection
 */

TagsApi.prototype.findGenreVideoIndex = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.FindGenreVideoIndex
});
/**
 * get suggested tags for apps
 */

TagsApi.prototype.listSuggestedTags = makeMethod({
  method: 'get',
  path: Request.Tags.Paths.ListSuggestedTags
});